'use strict';
import { module } from '../app';
import moment from 'moment';
import { constantStrings, DEFAULT_CHECK_WORKLIST_EXIST_ERROR, DEFAULT_CREATE_WORKLIST_ERROR } from '../constants/constantStrings';
import * as worklistConstants from '../constants/worklist-constants';

module
  .factory('studyDetailsViewModel', [
    '$state', '$filter', 'Study', 'Worklist', 'modalService', '$ionicLoading', 'signalrService', 'authService', 'techpadOptions', 'environmentHelper', '$location',
    function ($state, $filter, Study, Worklist, modalService, $ionicLoading, signalrService, authService, techpadOptions, environmentHelper, $location) {
      let vm = function (accessToken, sdate) {
        let self = this;
        self.accessToken = accessToken;
        techpadOptions.getOptions();
        self.darkMode = techpadOptions.options.DarkMode;
        self.isIOSDevice = environmentHelper.isIOSDevice();

        self.allowedStatusesToSkipSurvey = [
          'New',
          'SurveyStarted',
          'SurveyFinished'
        ];
        self.allowedStatusesToStartSurvey = [
          'New',
          'SurveyStarted'
        ];
        self.sides = [ {
          Key: 'L',
          Value: 'Left'
        }, {
          Key: 'R',
          Value: 'Right'
        }, {
          Key: 'B',
          Value: 'Both'
        }, {
          Key: 'U',
          Value: 'No side'
        } ];

        self.getFullSideByCode = function(code){
          let side = self.sides.find(side => {return side.Key === code});
          return side && side.Value || code;
        }

        self.isOnline = () => signalrService.isConnected;

        self.showValidationErrors = false;

        Worklist.getLocations().then(function (resp) {
          self.locations = resp.data;
        });

        Worklist.getProcedures().then(function (resp) {
          self.procedures = resp.data;
        });

        if (sdate) {
          Study.loadByAccessToken(accessToken, sdate).then(function (resp) {
            self.study = resp.data;
            self.studyCopy = angular.copy(resp.data);
          });
        } else {
          self.study = {PatientAccessToken: accessToken, StudyDate: moment().format().substr(0, 10), Procedures: []};
          self.studyCopy = angular.copy(self.study);
        }

        self.save = async function () {
          if (self.study.SDate) {
            const actionCanBePerformed = await self.checkIfActionCanBePerformed(self.study.Ssn, self.study.SDate);
            if(!actionCanBePerformed){
              return;
            }
          }
          if (!signalrService.isConnected) {
            await modalService.showAlertAsync(`You are currently offline, please check your network settings and try again`);
            if (!self.reconnectTimeout) {
              self.reconnectTimeout = setTimeout(() => {
                signalrService.tryReconnectAgain();
                clearTimeout(self.reconnectTimeout);
              }, 10000);
            }
            return;
          }

          if (!self.study.Location || self.study.Procedures.length == 0) {
            modalService.showAlert("You must specify location and procedures");
            return;
          }

          if (self.validate()) {
            $ionicLoading.show({
              template: 'Saving Study...'
            });
            const resp = await Study.post(self.study);
            $ionicLoading.hide();
            self.studyCopy = angular.copy(self.study);
            $state.go('root.study_details', {
              ssn: resp.data.Ssn,
              sdate: $filter('date')(resp.data.SDate, 'MM-dd-yyyy')
            });
          }
        };

        self.checkIfStudyChanged = function () {
          if (self.studyCopy) {
            if (self.study.Location !== self.studyCopy.Location ||
              !angular.equals(self.study.Procedures, self.studyCopy.Procedures)) {
              return true;
            }
          }
          return false;
        };

        self.validate = function () {
          if (!self.study || !self.study.Location || !self.study.Procedures.length) {
            self.showValidationErrors = true;
            return false;
          } else {
            return true;
          }
        };

        self.addToWorklist = async function () {
          let addToWorklistButtonClicked = true;
          if(!(await self.checkIfActionCanBePerformed(self.study.Ssn, self.study.SDate, addToWorklistButtonClicked))){
            return;
          }
          await self.createPin();
        };

        self.createPin = async function (skipStartSurvey) {
          $ionicLoading.show({
            template: constantStrings.GeneratingPinLoadingMessage
          });
          Study.generatePinNumber(self.study.Ssn, self.study.SDate).then(
            (resp) => {
              $ionicLoading.hide();
              self.study.Pin = resp.data;
              self.studyCopy.Pin = resp.data;
              if(!skipStartSurvey){
                Study.startSurvey(self.study.Ssn, self.study.SDate, resp.data)
                .catch(ex => {
                  modalService.showErrorMessage(ex.data.message, ex.status);
                });
              }
            },
            (errorResp) => {
              $ionicLoading.hide();
              modalService.showErrorMessage(errorResp);
            });
        };

        self.checkIfActionCanBePerformed = async function(ssn, sdate, addToWorklistButtonClicked, skipSurveyButtonClicked, startSurveyButtonClicked){
          let studyCompisiteId = {
            Ssn: ssn,
            SDate: sdate
          }
          let studyLocked = await Worklist.checkStudyLockBySsnAndSdate(studyCompisiteId);
          if(studyLocked.data.IsLock){
            modalService.showAlert(`This exam is now taken by ${studyLocked.data.CurrentUser.UserName}. You cannot perform this action`);
            return false;
          }
          let worklistOwnerResp = await Worklist.checkIfWorklistExists(studyCompisiteId);
          if(worklistOwnerResp && worklistOwnerResp.data && worklistOwnerResp.data.technologistEmail){
            if(worklistOwnerResp.data.technologistEmail.toLowerCase() !== (authService.getUserName() || '').toLowerCase()){
              if(worklistOwnerResp.data.isAllowedStatusToBeChangedFromCompleted === 'True' && addToWorklistButtonClicked){
                modalService.showConfirmation(async function () {
                  const isTakeOwnership = true;
                  await self.assignAndOpen(worklistOwnerResp.data.worklistId, isTakeOwnership);
                }, 'This exam is owned by technologist ' + (worklistOwnerResp.data.technologistName) + '. Are you sure to take over this exam ?');
              } else {
                modalService.showAlert(`This exam is now taken by ${worklistOwnerResp.data.technologistName}. You cannot perform this action`);
                return false;
              }
            }else{
              if(worklistOwnerResp.data.isAllowedStatusToBeChangedFromCompleted === 'True' && addToWorklistButtonClicked){
                await self.unlockAndChangeStatus(worklistOwnerResp.data.worklistId);
              }else if(skipSurveyButtonClicked){
                if(worklistOwnerResp.data.status &&
                  self.allowedStatusesToSkipSurvey.some(status => {return status.toLowerCase() === worklistOwnerResp.data.status.toLowerCase()}) ){
                    return true;
                }else{
                  modalService.showAlert(`You cannot perform this action. Exam in progress or completed`);
                  return false;
                }
              } else if(startSurveyButtonClicked){
                if(worklistOwnerResp.data.status &&
                  self.allowedStatusesToStartSurvey.some(status => {return status.toLowerCase() === worklistOwnerResp.data.status.toLowerCase()})){
                    return true;
                }else{
                  modalService.showAlert(`You cannot perform this action. Worklist is waiting for exam, or exam is progress or completed`);
                  return false;
                }
              }
            }
          }
          return true;
        };

        self.executeUpdateStatus = async function(){
          await Worklist.updateStatus(worklistId, res.data.allowedStatusToBeChanegdFromCompleted);
        };

        self.unlockAndChangeStatus = async function(worklistId){
          Worklist.unlockExam(worklistId).then(
            async function (res) {
            if(res.data.currentWorklistStatus === "Finished"){
              await modalService.showConfirmation(
                self.executeUpdateStatus,
                `This worklist was completed. Are you sure to change status to "${res.data.allowedStatusToBeChanegdFromCompleted}" ?`);
            }
            await self.createPin(true);
          },
          function (errorResp){
            $ionicLoading.hide();
            modalService.showErrorMessage(errorResp);
          });
        }

        self.confirmOwnerShipTaken = function (item) {
          let errorObject = {};
          errorObject.data = {
            Context: 'Ownership switching requested',
            CurrentWorklistTech: item.Technologist
          };
          errorObject.timestamp = new Date();
          errorObject.hospital = localStorage.getObject('hospital');
          errorObject.user = getUser();
          errorObject.device = localStorage.getObject('MagViewDeviceInfo');

          $http.post(authService.currentMagViewUrl() + '/api/logging/logTechpadErrors', [errorObject]).then(function () {
            // all errors send successfully
          }, function () { });

          modalService.showConfirmation(function () {
            const isTakeOwnership = true;
            self.assignAndOpen(item, isTakeOwnership);
          }, 'This exam is owned by technologist ' + (item.Technologist.FirstName + ' ' + item.Technologist.LastName) + '. Are you sure to take over this exam ?');
        };

        self.assignAndOpen = async function (worklistId, isTakeOwnership) {
          Worklist.assignToMe(worklistId, isTakeOwnership).then(async function (resp) {
            if (resp.data.IsSuccess) {
              await self.unlockAndChangeStatus(worklistId);
            } else {
              if (resp.data.IsOwnershipTakingRequired) {
                self.confirmOwnerShipTaken(worklistId);
              } if (!!resp.data.StudyLockModel) {
                modalService.showAdvancedConfirmation(
                  'Cannot perform exam',
                  'User \'' + resp.data.StudyLockModel.UserName + '\' on workstation \'' + resp.data.StudyLockModel.ClientWorkstation + '\' is currently modifying this study. ' +
                  'You will be able to review current study information, but not change or save the study. ' +
                  'This event was started on ' + moment(resp.data.StudyLockModel.LockedFrom).calendar(), [ {
                    text: 'Unlock this exam',
                    type: 'button-assertive',
                    onTap: function (e) {
                      modalService.showAdvancedConfirmation(
                        'Unlock Exam Confirmation',
                        'Are you sure to remove lock from this study and assign it to you ?', [ {
                          text: 'No',
                          onTap: function (e) {
                          }
                        }, {
                          text: 'Yes, Unlock It',
                          type: 'button-assertive',
                          onTap: function (e) {
                            Worklist.unlockExam(worklistId).then(function () {
                              const _isTakeOwnership = true;
                              self.assignAndOpen(worklistId, _isTakeOwnership);
                            });
                          }
                        } ]);
                    }
                  }, {
                    text: 'Cancel',
                    type: 'button-positive',
                    onTap: function (e) {}
                  } ]);
              } else {
                modalService.showAlert('This study record not found in database');
              }
            }
          }, function (resp, status) {
            modalService.showErrorMessage(resp.data, resp.status);
          });
        }

        self.createPinAsync = async function (skipStartSurvey) {
          const generatePinResponse = await Study.generatePinNumber(self.study.Ssn, self.study.SDate);
          self.study.Pin = generatePinResponse.data;
          self.studyCopy.Pin = generatePinResponse.data;
          if(!skipStartSurvey){
            await Study.startSurvey(self.study.Ssn, self.study.SDate, generatePinResponse.data);
          }
        }

        self.viewOnlyExam = async function () {
          let worklistId = null;
          let studyCompisiteId = {
            Ssn: self.study.Ssn,
            SDate: self.study.SDate
          }
          let canProceed = true;

          $ionicLoading.show();
          try {
            let worklistOwnerResp = await Worklist.checkIfWorklistExists(studyCompisiteId);
            worklistId = worklistOwnerResp && worklistOwnerResp.data && worklistOwnerResp.data.worklistId;
          } catch (error) {
            $ionicLoading.hide();
            canProceed = false;
            await modalService.showErrorMessage(error, DEFAULT_CHECK_WORKLIST_EXIST_ERROR);
          }

          if(canProceed && !worklistId){
            try {
              await self.createPinAsync();
            } catch (error) {
              $ionicLoading.hide();
              canProceed = false;
              await modalService.showErrorMessage(error, DEFAULT_CREATE_WORKLIST_ERROR);
            }
            if(canProceed){
              try {
                let worklistOwnerResp = await Worklist.checkIfWorklistExists(studyCompisiteId);
                worklistId = worklistOwnerResp && worklistOwnerResp.data && worklistOwnerResp.data.worklistId;
              } catch (error) {
                $ionicLoading.hide();
                canProceed = false;
                await modalService.showErrorMessage(error, DEFAULT_CHECK_WORKLIST_EXIST_ERROR);
              }
            }
          }

          if(canProceed){
            $location.path(`${worklistConstants.WORKLIST_PAGE_URL}${worklistId}`);
            $location.search({
              returnUrl: `${worklistConstants.STUDY_DETAILS_RETURN_URL}/${self.accessToken}/${self.study.SDate}`,
              viewOnly: true.toString()
            });
          }
          $ionicLoading.hide();
        }

        self.skipSurveyAndStartExam = async function () {
          let addToWorklistButtonClicked = false;
          let skipSurveyButtonClicked = true;
          if(!(await self.checkIfActionCanBePerformed(self.study.Ssn, self.study.SDate, addToWorklistButtonClicked, skipSurveyButtonClicked))){
            return;
          }
          if (self.checkIfStudyChanged()) {
            let confirmed = await modalService.showConfirmation(new function () {}, 'You have unsaved changes, are you sure you want to revert them?');
            if (!confirmed) {
              return;
            }
            self.skipSurveyAndStartExamProceed();
          } else {
            self.skipSurveyAndStartExamProceed();
          }
        };

        self.skipSurveyAndStartExamProceed = function () {
          $ionicLoading.show({
            template: 'Skipping Survey...'
          });
            Study.skipSurveyAndStartExam(self.study.Ssn, self.study.SDate).then(function (resp) {
              $ionicLoading.hide();
              $state.go('root.worklist');
              //self.study.Pin = '';
            }).catch(function (error) {
              $ionicLoading.hide();
              modalService.showErrorMessage(error.data, error.status);
            });
        };

        self.startSurvey = async function () {
          let addToWorklistButtonClicked = false;
          let skipSurveyButtonClicked = false;
          let startSurveyButtonClicked = true;
          if(!(await self.checkIfActionCanBePerformed(self.study.Ssn, self.study.SDate, addToWorklistButtonClicked, skipSurveyButtonClicked, startSurveyButtonClicked))){
            return;
          }
          if (self.checkIfStudyChanged()) {
            let confirmed = await modalService.showConfirmation(null, 'You have unsaved changes, are you sure you want to revert them?');
            if (!confirmed) {
              return;
            }
            self.startSurveyProceed();
          } else {
            self.startSurveyProceed();
          }
        };

        self.startSurveyProceed = function () {
          $ionicLoading.show({
            template: 'Starting Survey...'
          });
          Study.startSurvey(self.study.Ssn, self.study.SDate).then(resp => {
            let id = resp.data.id;
            Worklist.assignToMe(id).then(resp => {
              $ionicLoading.hide();
              $state.go('root.patient', {id: id});
            });
          }).catch(function (error) {
            $ionicLoading.hide();
            modalService.showErrorMessage(error.data, error.status);
          });
        };

        self.goBack = function () {
          const isStudyChanged = self.checkIfStudyChanged();
          if (isStudyChanged) {
            modalService.showConfirmation(null, constantStrings.DefaultRevertChangesConfirmationMessage)
              .then((isConfirmed) => {
                if (isConfirmed) {
                  $state.go('root.patient_details', { accessToken: self.accessToken });
                }
              });
          } else {
            $state.go('root.patient_details', {accessToken: self.accessToken});
          }
        };

        self.getLabel = function (key, collection) {
          if (!collection) {
            return '';
          }
          return (collection.filter(item => item.Key === key)[ 0 ] || {}).Value;
        };

        self.changeStudyDetailsLocation = function (item) {
          self.study.Location = item;
        };

        self.addProcedure = function (procedure) {
          if (!procedure) {
            return;
          }

          let p = {
            Code: procedure,
            Side: 'U'
          };
          self.study.Procedures.push(p);
        };

        self.removeProcedure = function (procedure) {
          self.study.Procedures.splice(self.study.Procedures.indexOf(procedure), 1);
        };

      };

      return vm;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/studyDetails.js